export default __webpack_public_path__ + "static/media/logo_grey.b6492cc7.png";